module.exports = __webpack_public_path__ + "img/PM_A01_front_de.4df66dac.png";